export default function TripAddToCalendarService(
    $http
) {
    'ngInject';

    Object.assign(this, {
        send,
    });

    function send(travellers, tripId) {
        const endpointSend = '/trips/AddToCalendar';
        const passengers = travellers.map(({id, email}) => ({id, email}));

        return $http.apiPOST(endpointSend, {
            tripId,
            passengers,
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/trip-add-to-calendar/trip-add-to-calendar-service.js